import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'swissCurrency',
    standalone: true
})
export class SwissCurrencyPipe implements PipeTransform {
    transform(value: number | null | undefined, showCHF = false, isInteger = false): string {
        if (value == null) return showCHF ? (isInteger ? 'CHF 0' : 'CHF 0.00') : (isInteger ? '0' : '0.00');

        const fractionDigits = isInteger ? 0 : 2;
        const options: Intl.NumberFormatOptions = {
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
        };

        if (showCHF) {
            options.style = 'currency';
            options.currency = 'CHF';
        } else {
            options.style = 'decimal';
        }

        return new Intl.NumberFormat('de-CH', options).format(value);
    }
}
